/**
 * Which stored columns this screen asks `qf-scr` for — the Impulse (JAS)
 * columns wave 1 handed to wave 2 (`source: compute` on a field the config
 * does not compute).
 *
 * The shown ones, the owner's choice, so a member receives what is on screen
 * and no more — **and whatever a ticked open condition reads, shown or not.**
 * The browser evaluates an open condition itself, over these values: Author as
 * JAS with MOMO hidden checked A+ and 2 Days MOMO Up against no MOMO at all and
 * kept no row (2026-10-19). A sealed condition is the server's and reads its
 * own row, so the open rules in `filter` are the whole list.
 */

import type { ScreenerColumn } from "@qufolio/model";
import { filterFields, type ColumnOrigin } from "@qufolio/screener-grid";

type ScreenerFilter = Parameters<typeof filterFields>[0];

export function liveStoredFields(
  columns: readonly ScreenerColumn[] | undefined,
  filter: ScreenerFilter | undefined,
  sources: ReadonlyMap<string, ColumnOrigin>,
): string[] {
  const shown = (columns ?? [])
    .filter((c) => !c.hide && !c.computed && sources.get(c.field) === "compute")
    .map((c) => c.field);
  const computed = new Set((columns ?? []).filter((c) => c.computed).map((c) => c.field));
  const read = [...filterFields(filter)].filter(
    (f) => !computed.has(f) && !shown.includes(f) && sources.get(f) === "compute",
  );
  return [...shown, ...read];
}
